<template>
	<div>
		<div class="header-item">
			<template v-if="roles['Admin'] || user.privileges.pages['settings/dashboard']">
				<DropDown :title="title" :mainslug="slug" :content="content"></DropDown>
			</template>
			<template v-else>
				<h1>{{title}}</h1>
			</template>
		</div>

		<router-view :content="allContent" :filtered="content"></router-view>

	</div>

</template>

<script>

import xhrModule from '../modules/xhrModule.js'
import DropDown from '../components/DropDown.vue'

export default {
	name: 'settings',
	components: {
		'DropDown': DropDown
	},
	data () {
		return {
			title: 'Settings',
			slug: 'settings',
			content: null,
			allContent: null,
			user: this.$store.state.user,
			roles: this.$store.state.user.roles
		}
	},

	created () {
		this.fetchData()
	},

	methods: {
		fetchData () {
			var url = '/cms/api/entities'
			xhrModule.get(url, this.getContentCompleteHandler.bind(this))
		},

		getContentCompleteHandler (data) {
			var dataLength = data.meta.count
			this.allContent = Object.values(data.data)

			data = data.data
			// select only contentType = settings
			var dataFiltered = []
			var int = 0
			for (var key in data) {
				int++
				if (data[key].settings) {
					if (data[key].settings.contentType) {
						if (data[key].settings.contentType.value === 'settings') dataFiltered.push(data[key])
					}
				}
				if (int === dataLength) {
					this.content = dataFiltered
				}
			}
		}
	}
}
</script>
